import { Modal } from "react-bootstrap";
import API from "../../axios.jsx";

const SEC = { fontSize: 11, fontWeight: 800, letterSpacing: 1, textTransform: "uppercase", color: "#16342a", background: "#eef1e7", borderRadius: 6, padding: "5px 11px", margin: "16px 0 8px" };
const FILA = { display: "flex", justifyContent: "space-between", gap: 12, padding: "5px 0", borderBottom: "1px solid #f1f3f5", fontSize: 13 };
const LBL = { color: "#6c757d", flexShrink: 0 };
const VAL = { fontWeight: 600, textAlign: "right" };

function Dato({ label, valor }) {
  if (valor === undefined || valor === null || valor === "" || valor === 0) return null;
  return (
    <div style={FILA}>
      <span style={LBL}>{label}</span>
      <span style={VAL}>{valor}</span>
    </div>
  );
}

const NOMBRE_MOTIVO = {
  contraindicacion: "Contraindicación médica", renuente: "Renuente",
  factores_salud: "Factores R/C servicio de salud", factores_familia: "Factores R/C la familia",
  sin_equipo: "No hay equipo vacunador", no_aplica: "No aplica", otros: "Otros",
};

export default function VerPaiModal({ show, onClose, registro }) {
  if (!registro) return null;
  const r = registro;
  const v = r.visita || {};
  const motivos = [
    ["Contraindicación médica", r.motivo_contraindicacion],
    ["Renuente", r.motivo_renuente],
    ["Factores servicio de salud", r.motivo_factores_salud],
    ["Factores de la familia", r.motivo_factores_familia],
    ["Otros", r.motivo_otros],
  ].filter(([, n]) => n > 0);

  return (
    <Modal show={show} onHide={onClose} centered scrollable size="lg">
      <Modal.Header closeButton style={{ background: "linear-gradient(135deg, #16342a, #2d6a4f)", color: "#fff" }}>
        <Modal.Title style={{ fontSize: "1rem" }}>💉 {v.codigo_vivienda}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={SEC}>📍 Vivienda</div>
        <Dato label="Territorio" valor={v.territorio} />
        <Dato label="Comunidad" valor={v.comunidad} />
        <Dato label="Dirección" valor={v.direccion} />
        <Dato label="Estado" valor={v.estado_vivienda} />
        <Dato label="Entrevistador" valor={v.entrevistador} />
        <Dato label="Líder BAC" valor={v.lider_bac} />
        <Dato label="Fecha" valor={v.createdAt?.split("T")[0]} />
        {v.foto_url && (
          <a href={`${API.defaults.baseURL}${v.foto_url}`} target="_blank" rel="noreferrer">
            <img src={`${API.defaults.baseURL}${v.foto_url}`} alt="Vivienda" style={{ width: "100%", maxHeight: 200, objectFit: "cover", borderRadius: 8, marginTop: 8 }} />
          </a>
        )}

        <div style={SEC}>👥 Población</div>
        <Dato label="Encontrados" valor={r.encontrada_total} />
        <Dato label="Vacunados previamente" valor={r.vacunada_previa_total} />
        <Dato label="NO vacunados en el barrido" valor={r.no_vacunada_barrido_total} />
        <Dato label="Vacunados durante el barrido" valor={r.vacunada_barrido_total} />
        {motivos.length > 0 && (
          <div style={{ marginTop: 6, fontSize: 12.5 }}>
            <span style={LBL}>Motivos de no vacunación: </span>
            {motivos.map(([k, n]) => `${k}: ${n}`).join(" · ")}
          </div>
        )}

        {r.vacunada_barrido_total > 0 && (
          <>
            <div style={SEC}>💉 Vacunación</div>
            <Dato label="Vacunador" valor={r.nombre_vacunador} />
            <Dato label="Biológico aplicado" valor={r.nombre_biologico} />
            <Dato label="Lote" valor={r.lote} />
          </>
        )}

        {r.biologico_pendiente === "Si" && (
          <>
            <div style={SEC}>⚠️ Biológico pendiente</div>
            <p style={{ fontSize: 13 }}>{r.biologico_pendiente_detalle || "Sí, sin detalle"}</p>
          </>
        )}

        {(r.carnets || []).length > 0 && (() => {
          const renderPersona = (c, i) => {
            const esRenuente = c.presenta_evidencia !== "Si";
            const eraRenuenteDeVerdad = esRenuente && (c.tipo_identificacion === "N/A" || String(c.numero_identificacion || "").startsWith("RENUENTE-"));
            return (
              <div key={i} style={{ padding: "10px 12px", background: "#f5f6f0", borderRadius: 8, marginBottom: 8 }}>
                <div className="d-flex align-items-center gap-2 mb-1">
                  <span style={{ fontSize: 13, fontWeight: 700 }}>{c.nombre}</span>
                  {esRenuente && (
                    <span className="badge bg-danger" style={{ fontSize: 10 }}>
                      {eraRenuenteDeVerdad ? "Renuente" : "No presenta carnet"}
                    </span>
                  )}
                </div>

                {esRenuente ? null : (
                  <>
                    <Dato label="Documento" valor={c.tipo_identificacion && c.numero_identificacion ? `${c.tipo_identificacion} ${c.numero_identificacion}` : null} />
                    <Dato label="Edad" valor={c.edad ? `${c.edad} ${c.unidad_edad || ""}` : null} />
                    {c.se_aplico_vacuna === "Si" && (
                      <>
                        <Dato label="Vacunador" valor={c.nombre_vacunador} />
                        <Dato label="Biológico" valor={c.nombre_biologico} />
                        <Dato label="Lote" valor={c.lote} />
                      </>
                    )}
                    {c.se_aplico_vacuna === "No" && <Dato label="Motivo" valor={NOMBRE_MOTIVO[c.motivo_no_vacunada] || c.motivo_no_vacunada} />}

                    <div className="d-flex gap-2 mt-2 flex-wrap">
                      {[
                        { url: c.foto_a_url, label: "Cara A" },
                        { url: c.foto_b_url, label: "Cara B" },
                        { url: c.foto_paiweb_url, label: "PAIWEB" },
                      ].map(({ url, label }) => (
                        url ? (
                          <a key={label} href={`${API.defaults.baseURL}${url}`} target="_blank" rel="noreferrer" className="text-center">
                            <img src={`${API.defaults.baseURL}${url}`} alt={label} style={{ width: 100, height: 100, objectFit: "cover", borderRadius: 8, border: "1px solid #dee2e6", display: "block" }} />
                            <div style={{ fontSize: 10.5, color: "#6c757d", marginTop: 2 }}>{label}</div>
                          </a>
                        ) : (
                          <div key={label} className="text-center">
                            <div style={{ width: 100, height: 100, borderRadius: 8, background: "#eef1e7", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, color: "#8a94a6" }}>Sin foto</div>
                            <div style={{ fontSize: 10.5, color: "#6c757d", marginTop: 2 }}>{label}</div>
                          </div>
                        )
                      ))}
                    </div>
                  </>
                )}
              </div>
            );
          };

          const grupos = [
            { titulo: "✓ Vacunadas previamente", color: "#2d6a4f", lista: r.carnets.filter(c => c.presenta_evidencia === "Si" && c.tiene_vacuna_sarampion === "Si") },
            { titulo: "💉 Vacunadas en el barrido", color: "#16342a", lista: r.carnets.filter(c => c.presenta_evidencia === "Si" && c.tiene_vacuna_sarampion === "No" && c.se_aplico_vacuna === "Si") },
            { titulo: "⏳ Pendientes por vacunar", color: "#b7791f", lista: r.carnets.filter(c => c.presenta_evidencia === "Si" && c.tiene_vacuna_sarampion === "No" && c.se_aplico_vacuna === "No") },
            { titulo: "⚠️ Datos incompletos — revisar", color: "#495057", lista: r.carnets.filter(c => c.presenta_evidencia === "Si" && (!c.tiene_vacuna_sarampion || (c.tiene_vacuna_sarampion === "No" && !c.se_aplico_vacuna))) },
            { titulo: "🚫 Sin carnet ni PAIWEB", color: "#b3261e", lista: r.carnets.filter(c => c.presenta_evidencia !== "Si") },
          ].filter(g => g.lista.length > 0);

          return (
            <>
              <div style={SEC}>🪪 Personas caracterizadas ({r.carnets.length})</div>
              {grupos.map(g => (
                <div key={g.titulo} className="mb-3">
                  <div style={{ fontSize: 11.5, fontWeight: 700, color: g.color, marginBottom: 6 }}>
                    {g.titulo} — {g.lista.length}
                  </div>
                  {g.lista.map((c, i) => renderPersona(c, i))}
                </div>
              ))}
            </>
          );
        })()}
      </Modal.Body>
    </Modal>
  );
}